import React, { useContext } from 'react';
import { isWidgetEnabled, WidgetContext } from '../../../data/widgets/WidgetContext';
import { getMatchIdOrStageId } from '../../utils/getMatchIdOrStageId';
import { getEnv } from '../../env';
import { getLabel } from '../../../data/labels';
import { getConfiguration } from '../../utils/configuration';

export default function LiveTrackerToggle(props) {
    const widgetContext = useContext(WidgetContext);
    const event = props.event;
    const isSnapshot = props.isSnapshot;
    const widgetEnabled = isWidgetEnabled(event.sportRef, event.widgetType, event.geniusId, event.lsportWidgetId);
    const conf = getConfiguration()

    if (isSnapshot) return null;
    if (!widgetEnabled || event.id == null) return null;

    function toggleLiveTracker(e) {
        e.preventDefault();
        e.stopPropagation();
        const containerId = `#br_widget_checkbet_${event.ticketRef}_${event.id}`;
        if (widgetContext.widgetContainerId !== containerId) {
            if (widgetEnabled) {
                widgetContext.setWidget({
                    widgetGeniusId: event.geniusId,
                    widgetLsportId: event.lsportWidgetId,
                    widgetProviderType: event.widgetType,
                    widgetSportId: event.sportRef,
                    widgetStartCollapsed: true,
                    widgetS5Layout: '#2',
                    widgetMatchId: getMatchIdOrStageId(event),
                    widgetContainerId: containerId,
                });
            }
        } else if (event.id !== widgetContext.widgetMatchId) {
            widgetContext.setWidget({ widgetMatchId: getMatchIdOrStageId(event) });
        } else {
            widgetContext.setWidget({ widgetMatchId: null, widgetContainerId: null });
        }
    }

    if (conf.ebv2r && event.id != null && isWidgetEnabled(event.sportRef, event.widgetType, event.geniusId, event.lsportWidgetId)) {
        const isOpen = widgetContext.widgetContainerId === `#br_widget_checkbet_${event.ticketRef}_${event.id}`;
        return (
            <div className="sc__stats-btn" onClick={toggleLiveTracker}>
                <span className="sc__stats-btn__label">
                    {getLabel('mybets.statistiche', 'Statistiche')}
                </span>
                <img
                    src={`${getEnv('PUBLIC_URL')}/assets/images/arrow.svg`}
                    alt=""
                    className={`sc__stats-btn__arrow ${isOpen ? 'sc__stats-btn__arrow--up' : ''}`}
                />
            </div>
        );
    }
    // Default campetto 
    return (
        <>
            {(event.id != null && isWidgetEnabled(event.sportRef, event.widgetType, event.geniusId, event.lsportWidgetId)) &&
                <img src={`${getEnv('PUBLIC_URL')}/assets/images/widget-campetto.png`} alt="" height="20px" width="28px" onClick={toggleLiveTracker} />
            }
        </>
    );
}